import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../../../components/UI/ListLinkBox';
import { translate } from '../../../../../utils/util';
import { checkPermission, getVision } from '../../../../../services/auth';
import BackButton from '../../../../../components/UI/BackButton';
import { PERMISSIONS, ENUMS, VISIONS } from '../../../../../utils/constants';
import * as actionsLinePicking from '../../../../../actions/linePickingAction';
import * as deliveryAction from '../../../../../actions/deliveryAction';

const Delivery = (props) => {
    const menu = () => {
        let menuItems = [];
        if (checkPermission(PERMISSIONS.Delivery.Filters) && getVision() !== VISIONS.Fiasa) {
            menuItems = [...menuItems, { route: 'delivery/filter', icon: 'mdi mdi-filter-outline', text: translate('general.filter', 'delivery') }];
        }

        if (getVision() === VISIONS.Fiasa) {
            menuItems = [...menuItems, { route: 'delivery/ordersList', icon: 'mdi mdi-motion-play-outline', text: "Todos" }];
        }

        if (getVision() !== VISIONS.Fiasa) {
            menuItems = [...menuItems, { route: 'delivery/startdelivery', icon: 'mdi mdi-motion-play-outline', text: translate('general.startDelivery', 'delivery') }];

            if (checkPermission(PERMISSIONS.LinePicking.SmallParts.Route)) {
                menuItems = [...menuItems, { route: 'deliveryroute/home', icon: "mdi mdi-map-marker-path", text: translate('route-x-pdu', 'route-delivery') }];
            }
            menuItems = [...menuItems, {
                onClick: () => {
                    props.setFilterManualCall({});
                },
                route: 'delivery/manualCall', icon: 'mdi mdi-gesture-tap-hold', text: translate('delivery:general.manualOrder')
            }];
        }

        menuItems = [...menuItems, {
            route: {
                pathname: 'endCalls',
                state: { orderType: ENUMS.eOrderType.Delivery.value }
            },
            icon: "mdi mdi-close-network-outline",
            text: translate('line-picking:endCalls:endCall')
        }];

        return menuItems;
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-cart-check" />
                        {translate('title', 'delivery')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};
export const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        setFilter: (filter) => {
            dispatch(actionsLinePicking.setFilter(filter));
        },
        setFilterManualCall: (filter) => {
            dispatch(deliveryAction.setFilterManualCall(filter));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Delivery)));

